module.exports = __webpack_public_path__ + "img/home_adapt_exit_normal.3d197391.svg";